/* eslint-disable no-constant-condition */
import { useAlert } from 'providers/AlertModalProvider';
import { useModal } from 'providers/ConfirmationModalProvider';
import postData from 'services/postData';

const useHandleChangeStatus = () => {
  const { showConfirmation } = useModal();
  const { showAlert } = useAlert();

  const handleChangeStatus = async ({
    label,
    name,
    status,
    url,
    handleLoading,
    payLoad,
    handleRefresh
  }) => {
    const mainStatus = status;
    showConfirmation({
      onConfirm: async () => {
        handleLoading(true, 'Changing status');
        const requestStatus = await postData(payLoad, url);
        if (requestStatus.status) {
          handleLoading(false);
          showAlert({
            variant: 'info',
            message: `Approval has been successfully raised to ${
              mainStatus === 'Active' ? 'disable' : 'active'
            } ${label} ${name}.`
          });
          handleRefresh();
        } else {
          if (requestStatus.message?.includes('flag has already')) {
            handleLoading(false);
            showAlert({
              variant: 'warning',
              message: `Failed to ${
                mainStatus === 'Active' ? 'disable' : 'active'
              } the ${label}; this ${label} approval is pending.`
            });
            handleRefresh();
          } else {
            handleLoading(false);
            showAlert({
              variant: 'danger',
              message: `Failed to  ${
                mainStatus === 'Active' ? 'disable' : 'active'
              } the ${label} ${name}. Please try again.`
            });
          }
        }
      },
      message: `Are you sure you want to ${
        mainStatus === 'Active' ? 'disable' : 'activate'
      } the ${label} ${name}?`,
      icon: 'streamline:warning-triangle-solid',
      severity: 'warning',
      confirmBtn: mainStatus === 'Active' ? 'Disable' : 'Activate'
    });
  };

  return handleChangeStatus;
};

export default useHandleChangeStatus;
